var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"items"},_vm._l((_vm.values),function(item){return _c('div',[_c('div',{staticClass:"item",class:_vm.selected==item.key ? 'active':'',on:{"click":function($event){return _vm.handleInput(item.key)}}},[_vm._v(" "+_vm._s(item.text)+" ")])])}),0)
}
var staticRenderFns = []

export { render, staticRenderFns }